import React, {useEffect, useState, useMemo } from 'react';
import ProtectedRoute from '../../routes/protected';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import FormCreatePerformanceReview from '../../components/performance/forms/formCreatePerformanceReview';
import { useNavigate, useLocation } from 'react-router-dom';

export default function CreatePerformanceReview() {

    const navigate = useNavigate();
    const location = useLocation();
    const [assessmentType, setAssessmentType] = useState('')

    useEffect(() => {

        if (location && location.state && location.state.assessmentType) {
            setAssessmentType(location.state.assessmentType)

        }
        
    }, [])

    const getForm = useMemo(() => {

        return <FormCreatePerformanceReview assessment_type={assessmentType} />

    }, [assessmentType])
    
    return (
        <ProtectedRoute>

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <div className='col text-bg-green p-3'>
                        <span className="fs-6 fw-bold ps-5 text-decoration-none text-white" role='button' onClick={() => navigate(-1)}>
                            <FontAwesomeIcon className='' icon={solid('arrow-left')} /> Performance
                        </span>
                    </div>
                </div>
                <div className='d-flex-auto my-4 mx-5 pt-3 bg-white contentShadow rounded-top paddingBottom200' style={{minHeight: '500px'}}>
                    <div className='col-md-6 col-10'>
                        <div className='ps-3'>
                            {getForm}
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}